import React from 'react';
import { ChevronLeft } from 'lucide-react';
import '../../styles/mobile-dark.css';

const TenantMobileLayout = ({ title, children, onBack }) => {
  return (
    <div className="min-h-screen relative">
      {/* Background Image */}
      <div 
        className="fixed inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: 'url(/images/login-bg.png)' }}
      />
      {/* Dark Overlay */}
      <div className="fixed inset-0 bg-black/70" />
      
      {/* Grid pattern */}
      <div className="fixed inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:50px_50px]" />

      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col">
        {/* Header: parte subito sotto la barra di stato (safe area) */}
        <header
          data-testid="tenant-mobile-header"
          className="sticky top-0 z-20 px-4 pb-3 bg-[#05070f]/95 backdrop-blur-md border-b border-cyan-500/20"
          style={{ paddingTop: 'calc(env(safe-area-inset-top, 0px) + 12px)' }}
        >
          <div className="flex items-center gap-3">
            <button
              onClick={onBack}
              data-testid="tenant-mobile-back-btn"
              className="w-10 h-10 rounded-xl bg-white/10 border border-cyan-500/30 flex items-center justify-center active:scale-95 transition-transform"
            >
              <ChevronLeft className="h-5 w-5 text-cyan-400" />
            </button>
            <h1 className="text-xl font-bold text-white">{title}</h1>
          </div>
        </header>

        {/* Page Content (nessun overflow: le finestre a tutto schermo non vengono tagliate su iOS) */}
        <main className="flex-1 p-4" style={{ paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 16px)' }}>
          {children}
        </main>
      </div>
    </div>
  );
};

export default TenantMobileLayout;
